/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import { Button } from '@carbon/react';
import Invoker from '../utils/invoker';
import { getOauthErrorMessage } from '../utils/error-message-handler';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TestToolRefreshToken = ({ config, onClick }) => {
  const [authToken, setAuthToken] = useState({ access_token: '' });
  const [authError, setAuthError] = useState({});
  const invoker = useMemo(() => new Invoker(), []);
  const { t } = useTranslation();

  const refreshToken = async () => {
    let { identification } = config;
    let oauthRefreshUrl = config.flags.selectedRefreshUrl ? config.flags.selectedRefreshUrl : config.flags.selectedTokenUrl;
    let token = Object.assign(authToken);
    let error = {};
    try {
      let response = await invoker.refreshToken(oauthRefreshUrl, token, identification.clientID, identification.clientSecret);

      setAuthError(error);
      Object.keys(response).forEach(function (key) {
        token[key] = response[key];
      });
    } catch (err) {
      console.error(err.stack);
      let error = await getOauthErrorMessage(err, t);
      setAuthError(error);
    } finally {
      setAuthToken(token);
      if (onClick && typeof onClick === 'function') {
        onClick({ authToken: token, authError: error });
      }
    }
  };

  return (
    <div className="refreshToken">
      <Button className="refreshTokenButton" id="refreshTokenButton" onClick={refreshToken}>
        {t('explorer_refresh_token')}
      </Button>
      {authError && authError.highlightedText && (
        <div className="authError">
          <pre>
            <code className="boundedSection hljs oauthError" dangerouslySetInnerHTML={authError.highlightedText} />
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestToolRefreshToken;
